import { render, staticRenderFns } from "./WBtnDeactivate.vue?vue&type=template&id=1cebdff0&scoped=true&"
import script from "./WBtnDeactivate.vue?vue&type=script&setup=true&lang=js&"
export * from "./WBtnDeactivate.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cebdff0",
  null
  
)

export default component.exports